import { Pipe, PipeTransform, inject } from "@angular/core";
import { LanguageService, DateService } from "@services";
import { format } from "date-fns";

@Pipe({
    name: "formatDate",
    pure: true,
})
export class FormatDatePipe implements PipeTransform {
    private readonly languageService = inject(LanguageService);
    private readonly dateService = inject(DateService);

    transform(value: Date | number, cfg: "full" | "date" | "datetime" = "datetime"): string {
        const date = new Date(value);
        if (value) {
            const locale = this.languageService.locale();
            if (cfg === "date") {
                const dateFormat = this.dateService.dateFormat();
                return format(date, dateFormat, { locale });
            } else if (cfg === "datetime") {
                const dateTimeFormat = this.dateService.dateTimeFormat();
                return format(date, dateTimeFormat, { locale });
            } else {
                const fullDateTimeFormat = this.dateService.fullDateTimeFormat();
                return format(date, fullDateTimeFormat, { locale });
            }
        }
        return "";
    }
}
